const makeConstant = (constant) => `experiments/${constant}`

export const SET_LOADED = makeConstant('SET_LOADED')
export const TIMED_OUT = makeConstant('TIMED_OUT')
export const SET_PENDING = makeConstant('SET_PENDING')

export const ENROLL_USER_IN_EXPERIMENT = makeConstant(
  'ENROLL_USER_IN_EXPERIMENT'
)
